import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Spinner } from "reactstrap";
import api from "../../utils/api";
import { FILE_BASE_URL } from "../../utils/api";

const PrintActivistView = () => {
  const { id } = useParams();
  const [activist, setActivist] = useState(null);
  const [loading, setLoading] = useState(true);
  const [images, setImages] = useState([]);
  const [statements, setStatements] = useState([]);
  const [activities, setActivities] = useState([]);
  const [organizations, setOrganizations] = useState([]);

  useEffect(() => {
    fetchActivist();
  }, []);

  const fetchActivist = async () => {
    try {
      const response = await api.get(`/activists/${id}`);
      if (response.data && response.data.data) {
        const activistData = response.data.data;
        setActivist(activistData);

        // تحميل الصور
        if (activistData.images) {
          try {
            setImages(parseArrayField(activistData.images));
          } catch (e) {
            setImages([]);
          }
        }

        // تحميل التصريحات الجديدة
        if (activistData.statements) {
          try {
            setStatements(parseArrayField(activistData.statements));
          } catch (e) {
            console.error("فشل في قراءة التصريحات:", e);
            setStatements([]);
          }
        }

        // تحميل الأنشطة
        if (activistData.activities) {
          try {
            setActivities(parseArrayField(activistData.activities));
          } catch (e) {
            setActivities([]);
          }
        }

        // تحميل المنظمات
        if (activistData.organizations) {
          try {
            setOrganizations(parseArrayField(activistData.organizations));
          } catch (e) {
            setOrganizations([]);
          }
        }
      }
    } catch (error) {
      console.error("Error fetching activist:", error);
    } finally {
      setLoading(false);
    }
  };

  const parseArrayField = (field) => {
    if (!field) return [];
    if (Array.isArray(field)) return field;
    try {
      return JSON.parse(field);
    } catch {
      return [];
    }
  };

  const handlePrint = () => {
    window.print();
  };

  if (loading) {
    return (
      <div style={{
        minHeight: "100vh",
        background: "#f5f5f5",
        display: "flex",
        alignItems: "center",
        justifyContent: "center"
      }}>
        <div style={{
          background: "white",
          padding: "40px",
          textAlign: "center",
          border: "1px solid #ddd"
        }}>
          <Spinner size="lg" />
          <p style={{ marginTop: "20px", fontSize: "18px" }}>جاري تحميل بيانات الناشط...</p>
        </div>
      </div>
    );
  }

  if (!activist) {
    return (
      <div style={{
        minHeight: "100vh",
        background: "#f5f5f5",
        display: "flex",
        alignItems: "center",
        justifyContent: "center"
      }}>
        <div style={{
          background: "white",
          padding: "40px",
          textAlign: "center",
          border: "1px solid #ddd"
        }}>
          <i className="mdi mdi-alert-circle" style={{ fontSize: "64px", color: "#666" }}></i>
          <h4 style={{ marginTop: "20px" }}>لم يتم العثور على بيانات الناشط</h4>
        </div>
      </div>
    );
  }

  return (
    <div style={{
      minHeight: "100vh",
      background: "#f5f5f5",
      padding: "20px"
    }}>
      <div className="container" style={{ maxWidth: "1000px", margin: "0 auto" }}>
        <div style={{
          background: "white",
          border: "1px solid #ddd"
        }}>

          {/* هيدر الناشط */}
          <div style={{
            background: "#f8f8f8",
            color: "#333",
            padding: "40px",
            borderBottom: "1px solid #ddd"
          }}>
            <div style={{ display: "flex", alignItems: "center", gap: "30px" }}>
              <div style={{ flexShrink: 0 }}>
                {activist.profile_image ? (
                  <img
                    src={`${FILE_BASE_URL}/uploads/images/${activist.profile_image}`}
                    alt="صورة الناشط"
                    style={{
                      width: "150px",
                      height: "150px",
                      objectFit: "cover",
                      border: "1px solid #ddd"
                    }}
                  />
                ) : (
                  <div style={{
                    width: "150px",
                    height: "150px",
                    background: "#f0f0f0",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    border: "1px solid #ddd"
                  }}>
                    <i className="mdi mdi-account-heart" style={{ fontSize: "60px", color: "#999" }}></i>
                  </div>
                )}
              </div>

              <div style={{ flex: 1 }}>
                <h1 style={{
                  fontSize: "2.5rem",
                  fontWeight: "bold",
                  marginBottom: "10px",
                  color: "#333"
                }}>
                  {activist.full_name || "بدون اسم"}
                </h1>

                <div style={{
                  display: "inline-block",
                  background: "#e0e0e0",
                  padding: "8px 20px",
                  fontSize: "1.1rem",
                  fontWeight: "500",
                  marginBottom: "20px"
                }}>
                  {activist.specialization || "ناشط مجتمعي"}
                </div>

                <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))", gap: "15px" }}>
                  {activist.mobile1 && (
                    <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                      <i className="mdi mdi-cellphone" style={{ fontSize: "18px", color: "#666" }}></i>
                      <span>{activist.mobile1}</span>
                    </div>
                  )}
                  {activist.email && (
                    <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                      <i className="mdi mdi-email" style={{ fontSize: "18px", color: "#666" }}></i>
                      <span>{activist.email}</span>
                    </div>
                  )}
                  {(activist.city_or_area || activist.country_province) && (
                    <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                      <i className="mdi mdi-map-marker" style={{ fontSize: "18px", color: "#666" }}></i>
                      <span>{[activist.country || 'فلسطين', activist.country_province, activist.city_or_area].filter(Boolean).join(", ")}</span>
                    </div>
                  )}
                </div>
              </div>

              <div style={{ textAlign: "center" }}>
                <button
                  onClick={handlePrint}
                  style={{
                    background: "#333",
                    border: "none",
                    color: "white",
                    padding: "12px 24px",
                    fontSize: "14px",
                    fontWeight: "600",
                    cursor: "pointer",
                    minWidth: "120px"
                  }}
                >
                  <i className="mdi mdi-printer me-2"></i>
                  طباعة
                </button>
              </div>
            </div>
          </div>

          <div style={{ padding: "40px" }}>
            
            {/* نبذة عن الناشط */}
            {activist.description && (
              <div style={{ marginBottom: "40px", padding: "20px" }}>
                <h3 style={{
                  color: "#333",
                  marginBottom: "20px",
                  fontSize: "1.5rem",
                  fontWeight: "bold",
                  borderBottom: "2px solid #333",
                  paddingBottom: "10px"
                }}>
                  نبذة شخصية
                </h3>
                <div style={{
                  background: "#f9f9f9",
                  padding: "25px",
                  fontSize: "1.1rem",
                  lineHeight: "1.8",
                  color: "#333",
                  border: "1px solid #ddd"
                }}>
                  {activist.description.replace(/<[^>]*>/g, "")}
                </div>
              </div>
            )}

            <div style={{
              display: "grid",
              gridTemplateColumns: "repeat(auto-fit, minmax(300px, 1fr))",
              gap: "30px",
              marginBottom: "40px"
            }}>

              {/* المعلومات الشخصية */}
              <div style={{
                background: "white",
                padding: "30px",
                border: "1px solid #ddd"
              }}>
                <h4 style={{
                  color: "#333",
                  marginBottom: "25px",
                  fontSize: "1.3rem",
                  fontWeight: "bold"
                }}>
                  المعلومات الشخصية
                </h4>

                {[
                  { label: "الاسم الكامل", value: activist.full_name, icon: "account" },
                  { label: "التخصص", value: activist.specialization, icon: "school" },
                  { label: "اللغات", value: activist.languages, icon: "translate" },
                  { label: "المهارات", value: activist.skills, icon: "star" },
                  { label: "تاريخ الميلاد", value: activist.birth_date, icon: "calendar" },
                  { label: "النوع الاجتماعي", value: activist.gender, icon: "human-male-female" }
                ].filter(item => item.value).map((item, index) => (
                  <div key={index} style={{
                    display: "flex",
                    alignItems: "center",
                    padding: "12px 0",
                    borderBottom: index < 5 ? "1px solid #eee" : "none"
                  }}>
                    <i className={`mdi mdi-${item.icon}`} style={{
                      fontSize: "18px",
                      color: "#666",
                      marginLeft: "12px",
                      minWidth: "18px"
                    }}></i>
                    <div style={{ flex: 1 }}>
                      <div style={{ fontWeight: "600", color: "#333", fontSize: "13px", marginBottom: "2px" }}>
                        {item.label}
                      </div>
                      <div style={{ color: "#555", fontSize: "15px" }}>{item.value}</div>
                    </div>
                  </div>
                ))}
              </div>

              {/* معلومات الاتصال */}
              <div style={{
                background: "white",
                padding: "30px",
                border: "1px solid #ddd"
              }}>
                <h4 style={{
                  color: "#333",
                  marginBottom: "25px",
                  fontSize: "1.3rem",
                  fontWeight: "bold"
                }}>
                  معلومات الاتصال
                </h4>

                {[
                  { label: "الجوال الأول", value: activist.mobile1, icon: "cellphone" },
                  { label: "الجوال الثاني", value: activist.mobile2, icon: "cellphone" },
                  { label: "البريد الإلكتروني", value: activist.email, icon: "email" },
                  { label: "واتساب", value: activist.whatsapp, icon: "whatsapp" },
                  { label: "فيسبوك", value: activist.facebook, icon: "facebook" },
                  { label: "تويتر", value: activist.twitter, icon: "twitter" }
                ].filter(item => item.value).map((item, index) => (
                  <div key={index} style={{
                    display: "flex",
                    alignItems: "center",
                    padding: "12px 0",
                    borderBottom: index < 5 ? "1px solid #eee" : "none"
                  }}>
                    <i className={`mdi mdi-${item.icon}`} style={{
                      fontSize: "18px",
                      color: "#666",
                      marginLeft: "12px",
                      minWidth: "18px"
                    }}></i>
                    <div style={{ flex: 1 }}>
                      <div style={{ fontWeight: "600", color: "#333", fontSize: "13px", marginBottom: "2px" }}>
                        {item.label}
                      </div>
                      <div style={{ color: "#555", fontSize: "15px" }}>{item.value}</div>
                    </div>
                  </div>
                ))}
              </div>

              {/* العنوان والموقع */}
              <div style={{
                background: "white",
                padding: "30px",
                border: "1px solid #ddd",
                gridColumn: "1 / -1"
              }}>
                <h4 style={{
                  color: "#333",
                  marginBottom: "25px",
                  fontSize: "1.3rem",
                  fontWeight: "bold"
                }}>
                  العنوان والموقع
                </h4>

                <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))", gap: "20px" }}>
                  <div style={{
                    background: "#f9f9f9",
                    padding: "20px",
                    border: "1px solid #ddd"
                  }}>
                    <h6 style={{ color: "#333", fontWeight: "bold", marginBottom: "15px" }}>
                      تفاصيل العنوان
                    </h6>
                    <div style={{ display: "grid", gap: "12px" }}>
                      <div><strong>الدولة:</strong> {activist.country || "فلسطين"}</div>
                      <div><strong>المحافظة:</strong> {activist.country_province || "-"}</div>
                      <div><strong>المدينة/المنطقة:</strong> {activist.city_or_area || "-"}</div>
                      <div><strong>تفاصيل العنوان:</strong> {activist.address_details || "-"}</div>
                    </div>
                  </div>

                  <div style={{
                    background: "#f9f9f9",
                    padding: "20px",
                    border: "1px solid #ddd"
                  }}>
                    <h6 style={{ color: "#333", fontWeight: "bold", marginBottom: "15px" }}>
                      معلومات إضافية
                    </h6>
                    <div style={{ display: "grid", gap: "12px" }}>
                      <div><strong>الحالة الاجتماعية:</strong> {activist.marital_status || "-"}</div>
                      <div><strong>العمل الحالي:</strong> {activist.current_job || "-"}</div>
                      <div><strong>الموقع الشخصي:</strong> {activist.website || "-"}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* المنظمات */}
            {organizations && organizations.length > 0 && (
              <div style={{ marginBottom: "40px" }}>
                <h3 style={{
                  color: "#2c3e50",
                  marginBottom: "20px",
                  fontSize: "1.5rem",
                  fontWeight: "bold",
                  borderBottom: "3px solid #9b59b6",
                  paddingBottom: "10px",
                  display: "flex",
                  alignItems: "center",
                  gap: "12px"
                }}>
                  <div style={{
                    width: "35px",
                    height: "35px",
                    borderRadius: "50%",
                    background: "linear-gradient(135deg, #9b59b6 0%, #8e44ad 100%)",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center"
                  }}>
                    <i className="mdi mdi-account-group" style={{ fontSize: "18px", color: "white" }}></i>
                  </div>
                  المنظمات والتطوع ({organizations.length})
                </h3>

                <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(300px, 1fr))", gap: "20px" }}>
                  {organizations.map((org, index) => (
                    <div key={index} style={{
                      background: "linear-gradient(135deg, #f3e5f5 0%, #e1bee7 100%)",
                      borderRadius: "15px",
                      padding: "25px",
                      border: "1px solid rgba(155,89,182,0.2)",
                      boxShadow: "0 5px 15px rgba(0,0,0,0.05)"
                    }}>
                      <h6 style={{ color: "#9b59b6", fontWeight: "bold", marginBottom: "15px", fontSize: "1.1rem" }}>
                        {org.name || `منظمة ${index + 1}`}
                      </h6>
                      <div style={{ display: "grid", gap: "8px", fontSize: "14px", color: "#2c3e50" }}>
                        {org.role && <div><strong>الدور:</strong> {org.role}</div>}
                        {org.period && <div><strong>الفترة:</strong> {org.period}</div>}
                        {org.description && <div><strong>الوصف:</strong> {org.description}</div>}
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            )}

            {/* الأنشطة */}
            {activities && activities.length > 0 && (
              <div style={{ marginBottom: "40px" }}>
                <h3 style={{
                  color: "#2c3e50",
                  marginBottom: "20px",
                  fontSize: "1.5rem",
                  fontWeight: "bold",
                  borderBottom: "3px solid #e67e22",
                  paddingBottom: "10px",
                  display: "flex",
                  alignItems: "center",
                  gap: "12px"
                }}>
                  <div style={{
                    width: "35px",
                    height: "35px",
                    borderRadius: "50%",
                    background: "linear-gradient(135deg, #e67e22 0%, #d35400 100%)",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center"
                  }}>
                    <i className="mdi mdi-calendar-check" style={{ fontSize: "18px", color: "white" }}></i>
                  </div>
                  الأنشطة والفعاليات ({activities.length})
                </h3>

                <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(300px, 1fr))", gap: "20px" }}>
                  {activities.map((activity, index) => (
                    <div key={index} style={{
                      background: "linear-gradient(135deg, #fdeee6 0%, #fcebda 100%)",
                      borderRadius: "15px",
                      padding: "25px",
                      border: "1px solid rgba(230,126,34,0.2)",
                      boxShadow: "0 5px 15px rgba(0,0,0,0.05)"
                    }}>
                      <h6 style={{ color: "#e67e22", fontWeight: "bold", marginBottom: "15px", fontSize: "1.1rem" }}>
                        {activity.title || `نشاط ${index + 1}`}
                      </h6>
                      <div style={{ display: "grid", gap: "8px", fontSize: "14px", color: "#2c3e50" }}>
                        {activity.location && <div><strong>المكان:</strong> {activity.location}</div>}
                        {activity.date && <div><strong>التاريخ:</strong> {activity.date}</div>}
                        {activity.description && <div><strong>الوصف:</strong> {activity.description}</div>}
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            )}

            {/* التصريحات الجديدة */}
            {statements && statements.length > 0 && (
              <div style={{ marginBottom: "40px" }}>
                <h3 style={{
                  color: "#2c3e50",
                  marginBottom: "20px",
                  fontSize: "1.5rem",
                  fontWeight: "bold",
                  borderBottom: "3px solid #f39c12",
                  paddingBottom: "10px",
                  display: "flex",
                  alignItems: "center",
                  gap: "12px"
                }}>
                  <div style={{
                    width: "35px",
                    height: "35px",
                    borderRadius: "50%",
                    background: "linear-gradient(135deg, #f39c12 0%, #e67e22 100%)",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center"
                  }}>
                    <i className="mdi mdi-comment-quote" style={{ fontSize: "18px", color: "white" }}></i>
                  </div>
                  التصريحات والأقوال ({statements.length})
                </h3>

                <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(350px, 1fr))", gap: "20px" }}>
                  {statements.map((statement, index) => (
                    <div key={index} style={{
                      background: "linear-gradient(135deg, #fff3cd 0%, #ffeaa7 100%)",
                      borderRadius: "15px",
                      padding: "25px",
                      border: "1px solid rgba(243,156,18,0.2)",
                      boxShadow: "0 5px 15px rgba(0,0,0,0.05)"
                    }}>
                      <h6 style={{ color: "#f39c12", fontWeight: "bold", marginBottom: "15px", fontSize: "1.1rem" }}>
                        {statement.title || `تصريح ${index + 1}`}
                      </h6>
                      <div 
                        style={{
                          color: "#2c3e50",
                          lineHeight: "1.6",
                          marginBottom: "15px",
                          fontSize: "14px"
                        }}
                        dangerouslySetInnerHTML={{ __html: statement.content }}
                      />
                      {statement.date && (
                        <div style={{
                          fontSize: "13px",
                          color: "#7f8c8d",
                          display: "flex",
                          alignItems: "center",
                          gap: "5px"
                        }}>
                          <i className="mdi mdi-calendar"></i>
                          {new Date(statement.date).toLocaleDateString('ar-EG')}
                        </div>
                      )}
                    </div>
                  ))}
                </div>
              </div>
            )}

            {/* معرض الصور */}
            {images && images.length > 0 && (
              <div style={{ marginBottom: "40px" }}>
                <h3 style={{
                  color: "#2c3e50",
                  marginBottom: "20px",
                  fontSize: "1.5rem",
                  fontWeight: "bold",
                  borderBottom: "3px solid #27ae60",
                  paddingBottom: "10px",
                  display: "flex",
                  alignItems: "center",
                  gap: "12px"
                }}>
                  <div style={{
                    width: "35px",
                    height: "35px",
                    borderRadius: "50%",
                    background: "linear-gradient(135deg, #27ae60 0%, #2ecc71 100%)",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center"
                  }}>
                    <i className="mdi mdi-image-multiple" style={{ fontSize: "18px", color: "white" }}></i>
                  </div>
                  معرض الصور ({images.length})
                </h3>

                <div style={{
                  display: "grid",
                  gridTemplateColumns: "repeat(auto-fill, minmax(200px, 1fr))",
                  gap: "20px"
                }}>
                  {images.slice(0, 6).map((image, index) => (
                    <div key={index} style={{
                      borderRadius: "15px",
                      overflow: "hidden",
                      boxShadow: "0 10px 30px rgba(0,0,0,0.1)"
                    }}>
                      <img
                        src={`${FILE_BASE_URL}/uploads/images/${image}`}
                        alt={`صورة ${index + 1}`}
                        style={{
                          width: "100%",
                          height: "150px",
                          objectFit: "cover"
                        }}
                      />
                      <div style={{
                        padding: "10px",
                        background: "white",
                        textAlign: "center",
                        fontSize: "13px",
                        color: "#7f8c8d"
                      }}>
                        صورة {index + 1}
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            )}

          </div>
        </div>
      </div>
    </div>
  );
};

export default PrintActivistView;